import { useContext } from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import { Link, useHistory } from 'react-router-dom';
import { CartContext } from '../context/cartcontext';
import { AuthContext } from '../context/usercontext';
import { auth } from '../FirebaseConfig';

const Navigation = ({uname}) => {
    const { user } = useContext(AuthContext);
    const { cart } = useContext(CartContext);
    const history = useHistory();
    
    return(
        <Navbar collapseOnSelect expand = 'lg' bg = 'dark' variant = 'dark' fixed = 'top' sticky = 'top'>
            <Navbar.Brand as = {Link} to = '/'>ShopperApp</Navbar.Brand>
            <Navbar.Toggle aria-controls = 'toggle' />
            <Navbar.Collapse id = 'toggle'>
            {
                user ? (user.email === 'admin@admin.com' ? (
                    <Nav className = 'ml-auto'>
                        <Nav.Link onClick = {() => {auth.signOut(); history.push('/')}}>Admin, logout</Nav.Link>
                        <Nav.Link as = {Link} to = '/addproduct'>Add Product</Nav.Link>
                    </Nav>) : (
                    <Nav className = 'ml-auto'>
                        <Nav.Link onClick = {() => {auth.signOut(); history.push('/')}}>{uname || user.displayName}, logout</Nav.Link>
                        <Nav.Link as = {Link} to = '/cart'>Cart ({cart.length})</Nav.Link>
                    </Nav>)) : (
                    <Nav className = 'ml-auto'>
                        <Nav.Link as = {Link} to = '/login'>Log In</Nav.Link>
                        <Nav.Link as = {Link} to = '/signup'>Sign Up</Nav.Link>
                    </Nav>)
            }
                    
            </Navbar.Collapse>
        </Navbar>
    );
}

export default Navigation;